import React, { useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useClickOutside } from '../../app/hooks/useClickOutside';
import { ChevronDown, LogOut, User, Settings } from 'lucide-react';
import { Account } from '../types';
import { getAccountIcon, getAccountRoleLabel, ACCOUNT_ROLE_COLORS } from '../logic/uiHelpers';
interface ProfileButtonProps {
  account: Account;
  onNavigate: (view: string) => void;
  onLogout: () => void;
}
export function ProfileButton({
  account,
  onNavigate,
  onLogout
}: ProfileButtonProps) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  useClickOutside(dropdownRef, () => setIsOpen(false), isOpen);
  const Icon = getAccountIcon(account.role);
  const colors = ACCOUNT_ROLE_COLORS[account.role];
  return <div className="relative" ref={dropdownRef} data-id="element-367">
      <button onClick={() => setIsOpen(!isOpen)} className="flex items-center gap-3 px-3 py-2 rounded-xl bg-white border border-slate-200 hover:border-slate-300 hover:shadow-sm transition-all focus:outline-none focus:ring-2 focus:ring-orange-400" data-id="element-368">
        <div className={`w-8 h-8 rounded-full ${colors.bg} flex items-center justify-center`} data-id="element-369">
          <Icon className={`w-4 h-4 ${colors.text}`} strokeWidth={2.5} data-id="element-370" />
        </div>
        <div className="hidden md:block text-left" data-id="element-371">
          <div className="text-sm font-bold text-slate-900 leading-tight" data-id="element-372">
            {account.displayName}
          </div>
          <div className="text-xs text-slate-500" data-id="element-373">
            {getAccountRoleLabel(account.role)}
          </div>
        </div>
        <ChevronDown className={`w-4 h-4 text-slate-400 transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-374" />
      </button>

      <AnimatePresence data-id="element-375">
        {isOpen && <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: -10
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: -10
      }} transition={{
        duration: 0.15,
        ease: 'easeOut'
      }} className="absolute top-full right-0 mt-2 w-56 bg-white rounded-xl shadow-xl border border-slate-200 overflow-hidden z-50" data-id="element-376">
            <div className="p-2 space-y-1" data-id="element-377">
              <button onClick={() => {
            onNavigate('settings');
            setIsOpen(false);
          }} className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg hover:bg-slate-50 text-slate-700 transition-colors text-sm font-medium" data-id="element-378">
                <User className="w-4 h-4 text-slate-400" data-id="element-379" />
                Mijn profiel
              </button>
              <button onClick={() => {
            onNavigate('settings');
            setIsOpen(false);
          }} className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg hover:bg-slate-50 text-slate-700 transition-colors text-sm font-medium" data-id="element-380">
                <Settings className="w-4 h-4 text-slate-400" data-id="element-381" />
                Instellingen
              </button>

              <div className="h-px bg-slate-100 my-1 mx-2" data-id="element-382" />

              <button onClick={() => {
            onLogout();
            setIsOpen(false);
          }} className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg hover:bg-rose-50 text-rose-600 transition-colors text-sm font-medium" data-id="element-383">
                <LogOut className="w-4 h-4" data-id="element-384" />
                Uitloggen
              </button>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}